import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import { API_URL } from "./baseApi";
import { FileUploadResponse, UploadResponse } from "types/globalTypes";

export const fileApi = createApi({
  reducerPath: "fileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token =
        (getState() as RootState).auth?.accessToken ||
            sessionStorage.getItem("accessToken");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Accept-Charset", "utf-8");

      return headers;
    },
  }),
  tagTypes: ["Files"],
  endpoints: (builder) => ({
    uploadFiles: builder.mutation<UploadResponse, File[]>({
      query: (files) => {
        const formData = new FormData();
        files.forEach((file) => {
          const decodedName = decodeURIComponent(encodeURIComponent(file.name));
          const renamedFile = new File([file], decodedName, {
            type: file.type,
          });
          formData.append("files", renamedFile);
        });

        return {
          url: "/file/upload",
          method: "POST",
          body: formData,
        };
      },
      transformResponse: (response: UploadResponse) => response,
      transformErrorResponse: (response) => {
        return response.data || "Upload failed";
      },
    }),

    getFileInfo: builder.query<FileUploadResponse, string>({
      query: (filename) => `/file/${filename}`,
      providesTags: (result, error, id) => [{ type: "Files", id }],
    }),
  }),
});

export const { useUploadFilesMutation, useGetFileInfoQuery } = fileApi;
